import * as _ from 'lodash';
import { stringSimilarity } from 'string-similarity-js';
import { EVENT_TYPE } from '../constants/match';
import { LEAGUES } from '../constants/leagues';

const HIGHLIGHTS_PLUS_RATING_LIMIT = 4;

export function isMatchEventPlayableByHighlightsPlusSubscriber(
  matchEvent,
  match
) {
  const leagueWithNoVideo = [
    LEAGUES.DAMALLSVENSKAN,
    LEAGUES.CUP,
    LEAGUES.FRIENDLY,
    LEAGUES.EUROPEAN,
    LEAGUES.FUTSAL,
  ].includes(match?.configLeagueName);

  if (leagueWithNoVideo) return false;

  const rating = _.get(matchEvent, 'rating', 0);

  switch (matchEvent.type) {
    case EVENT_TYPE.GOAL:
    case EVENT_TYPE.PENALTY_KICK:
    case EVENT_TYPE.PENALTY:
    case EVENT_TYPE.SECOND_WARNING:
      return true;
    case EVENT_TYPE.MISC:
    case EVENT_TYPE.OFFSIDE:
    case EVENT_TYPE.PENALTY_MISSED:
    case EVENT_TYPE.SHOT:
    case EVENT_TYPE.SHOT_ON_TARGET:
    case EVENT_TYPE.WARNING:
      if (rating >= HIGHLIGHTS_PLUS_RATING_LIMIT) {
        return true;
      }
      return false;
    case EVENT_TYPE.CORNER:
    case EVENT_TYPE.PERIOD_RESULT:
    case EVENT_TYPE.START:
    case EVENT_TYPE.SUBSTITUTION:
    case EVENT_TYPE.FREE_KICK:
    default:
      return false;
  }
}

export function isMatchEventToShowPlayIconWhenPublicallyAvailable(matchEvent) {
  switch (matchEvent.type) {
    case EVENT_TYPE.CORNER:
    case EVENT_TYPE.GOAL:
    case EVENT_TYPE.OFFSIDE:
    case EVENT_TYPE.PENALTY:
    case EVENT_TYPE.PENALTY_KICK:
    case EVENT_TYPE.PENALTY_MISSED:
    case EVENT_TYPE.WARNING:
    case EVENT_TYPE.SHOT:
    case EVENT_TYPE.SHOT_ON_TARGET:
    case EVENT_TYPE.SECOND_WARNING:
      return true;
    case EVENT_TYPE.MISC:
    case EVENT_TYPE.PERIOD_RESULT:
    case EVENT_TYPE.START:
    case EVENT_TYPE.SUBSTITUTION:
    case EVENT_TYPE.FREE_KICK:
    default:
      return false;
  }
}

export function isMatchEventPlayable(
  match,
  matchEvent,
  isHighlightsPlusSubscriber = false
) {
  const videoIsAvailable = _.get(matchEvent, 'video.webUrl', null);
  const leagueWithNoVideo = [
    LEAGUES.DAMALLSVENSKAN,
    LEAGUES.CUP,
    LEAGUES.FRIENDLY,
    LEAGUES.EUROPEAN,
    LEAGUES.FUTSAL,
  ].includes(match?.configLeagueName);

  if (leagueWithNoVideo) {
    return false;
  }

  if (!videoIsAvailable) {
    return false;
  }

  if (match?.isAvailablePublicly) {
    return isMatchEventToShowPlayIconWhenPublicallyAvailable(matchEvent);
  }
  if (
    isMatchEventPlayableByHighlightsPlusSubscriber(matchEvent) &&
    isHighlightsPlusSubscriber
  ) {
    return true;
  }
  return false;
}

export function getFotbollPlayUrl(video) {
  const basePath = 'https://fotbollplay.se/playlist/';

  // eslint-disable-next-line no-unsafe-optional-chaining
  return basePath + video?.id;
}

export function getFutsalVideoUrl(video) {
  return `https://highlights.svenskafutsalligan.se/playlist/${video?.id}`;
}

export function hasPlayerScored(player, events) {
  const { givenName, surName } = player;
  const playerName = `${givenName} ${surName}`;
  const goals = events.filter((e) => e.type === EVENT_TYPE.GOAL);

  if (goals.length) {
    return goals.filter(
      (g) => stringSimilarity(g.playerName, playerName) > 0.7
    );
  }

  return [];
}

export function hasPlayerWarning(player, events) {
  const { givenName, surName } = player;
  const playerName = `${givenName} ${surName}`;
  const warnings = events.filter((e) => e.type === EVENT_TYPE.WARNING);

  if (warnings.length) {
    return warnings.find(
      (g) => stringSimilarity(g.playerName, playerName) > 0.7
    );
  }

  return false;
}

export function hasPlayerBeenSubstituted(player, events) {
  const { givenName, surName } = player;
  const playerName = `${givenName} ${surName}`;

  const subs = events.filter((e) => e.type === EVENT_TYPE.SUBSTITUTION);

  if (subs.length > 0) {
    const playerSub = subs.find((g) => {
      if (g?.inPlayerName && g?.outPlayerName) {
        const r = stringSimilarity(g.inPlayerName, playerName) > 0.7;
        const r2 = stringSimilarity(g.outPlayerName, playerName) > 0.7;

        return r || r2;
      }

      return false;
    });

    return playerSub;
  }

  return false;
}
